module.exports = __webpack_public_path__ + "static/badge-download-on-the-app-store-ad120213686c1200a66a650fb03abd1f.svg";